<template>
	<div :class="color" class="spinner-border spinner-border-sm" role="status">
		<span class="sr-only"></span>
	</div>
</template>

<script>
export default {
	name: 'SpinnerComponent',

	props: {
		color: {
			type: String,
			default: 'text-info'
		}
	}
}
</script>
